<template>
  <div>
    <McButton
      :variant="`${favotireRetport ? 'warning' : 'secondary-warning'}`"
      :text="$t('global.object.favorite')"
      :icon="`icon-${favotireRetport ? 'fill' : 'outline'}_star`"
      @click="onFavorite"
    />
  </div>
</template>
<script>
import McButton from '@/components/McButton'
import { UPDATE_FAVORITE_REPORTS } from '@/services/api/report/report'

export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentReport: this.report,
    }
  },
  components: {
    McButton,
  },
  computed: {
    favotireRetport() {
      return this.currentReport.isFavorite
    },
  },
  async mounted() {
    await this.$store.dispatch('report/setFavoriteReport')
  },
  methods: {
    async onFavorite() {
      this.currentReport.isFavorite = !this.currentReport.isFavorite
      let allReport = this.$store.state.report.reports
      let favReport = allReport.findIndex((item) => item.key == this.currentReport.key)
      await this.$apollo
        .mutate({
          mutation: UPDATE_FAVORITE_REPORTS,
          variables: {
            input: {
              reportKey: this.currentReport.key,
              status: this.currentReport.isFavorite,
              type: 'report',
            },
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ res, loading }) => {
          if (!loading) {
            allReport[favReport].isFavorite = this.currentReport.isFavorite
            this.$store.commit('report/updateReportList', allReport)
          }
        })
    },
  },
}
</script>
<style scoped lang="scss">
.icon-fill_star::before {
  color: #ffffff !important;
}
</style>
